// removed by extract-text-webpack-plugin
module.exports = {"siderCheckboxGroup":"index__siderCheckboxGroup___1-bAP","buttonsWrapper":"index__buttonsWrapper___U-sik"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/FilterCriteria/index.less
// module id = 1890
// module chunks = 3